import { useEffect, useRef, useState } from "react";
import { HexColorPicker } from "react-colorful";

interface ColorPickerProps {
  color: string;
  onChange: (color: string) => void;
  isOpen: boolean;
  onClose: () => void;
}

export const ColorPicker = ({
  color,
  onChange,
  isOpen,
  onClose,
}: ColorPickerProps) => {
  const pickerRef = useRef<HTMLDivElement>(null);
  const [inputColor, setInputColor] = useState(color);

  useEffect(() => {
    setInputColor(color);
  }, [color]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    if (isOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newColor = e.target.value;
    setInputColor(newColor);
    if (/^#([0-9A-F]{3}){1,2}$/i.test(newColor)) {
      onChange(newColor);
    }
  };

  return (
    <div ref={pickerRef} className="rounded-md bg-white p-3 shadow-lg border">
      <HexColorPicker color={color} onChange={onChange} />
      <input
        type="text"
        value={inputColor.toUpperCase()}
        onChange={handleInputChange}
        maxLength={7}
        className="mt-2 w-full rounded border p-1 text-center text-sm"
      />
    </div>
  );
};
